import { REPORT_STATUS_LABELS } from '@/constants/report';
import type { ReportRecord, ReportStatus } from '@/types/report';

interface MobileReportCardProps {
  report: ReportRecord;
  subtitle?: string;
  onClick?: () => void;
  highlightPending?: boolean;
}

function statusTagClass(status: ReportStatus, highlightPending?: boolean): string {
  if (highlightPending && status === 'SUBMITTED') {
    return 'mobile-tag mobile-tag--warning';
  }
  if (status === 'SUBMITTED') {
    return 'mobile-tag mobile-tag--primary';
  }
  return 'mobile-tag';
}

export function MobileReportCard({
  report,
  subtitle,
  onClick,
  highlightPending,
}: MobileReportCardProps) {
  const dateText = new Date(report.reportDate).toLocaleDateString('zh-CN');

  return (
    <article
      className="mobile-card"
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(event) => {
        if (onClick && (event.key === 'Enter' || event.key === ' ')) {
          onClick();
        }
      }}
    >
      <div className="mobile-card__header">
        <span className="mobile-card__title">{report.user.name}</span>
        <span className={statusTagClass(report.status, highlightPending)}>
          {REPORT_STATUS_LABELS[report.status]}
        </span>
      </div>
      <div className="mobile-card__meta">
        {dateText}
        {subtitle ? ` · ${subtitle}` : null}
      </div>
      <p className="mobile-card__body">{report.todayWork}</p>
    </article>
  );
}
